import 'twin.macro';
import HtmlViewer from '@teetsh/app/src/components/HtmlViewer';

interface Props {
  text: string;
  isStreaming?: boolean;
  onChange?: (text: string) => void;
}

export function StreamingHtmlViewer({
  text,
  isStreaming = true,
  onChange = () => {},
}: Props) {
  return (
    <div tw="relative">
      <HtmlViewer text={text} onChange={onChange} />
      {isStreaming && (
        <span tw="ml-0.5 inline-block w-0.5 h-4 bg-neutral-intense animate-pulse" />
      )}
    </div>
  );
}
